export class PaymentRequest {
    type: string;
    idProfile: number;
    installments: number;
    constructor() { }
}
